<template>
	<view></view>
</template>

<script>
	export default {
		onLoad(options) {
			uni.redirectTo('/shop/pages/mine/mine')
		}
	}
</script>

<style lang="scss" scoped></style>